import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isIdentified } from '../../ui/builders/utils';
import Header from './Header/Header';
import UnidentifiedHeader from '../../pages/ContestPage/unidentifiedHeader/UnidentifiedHeader';
import classes from './LayoutContest.module.css';

const LayoutContest = () => {

  const authState = useSelector((state) => state.auth);
  const identified = isIdentified(authState);
  const isInIframe = window.self !== window.top;

  return (
    <div className={classes.layout}>
      {(!identified || !isInIframe) && <UnidentifiedHeader />}
      <Header />
      <Outlet />
    </div>
  );
};

export default LayoutContest;